import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import Logos from '../../img/images/logos.png'

export function Navbar() {

    return (
        <nav className="navbar navbar-expand-lg navbar-light fixed-top scrolling-navbar white" >
            <div class="container" >
                <Link
                    to="/"
                    className="navbar-brand font-weight-bold title">
                    <img src={Logos} style={{ width: '10rem', padding: 0, margin: 0 }} alt="this is logo" />
                </Link>

                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo02"
                    aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse">
                    <ul className="list-unstyled navbar-nav mr-auto">
                        <li className="nav-item  ml-4 mb-0">
                            <Link
                                to="/"
                                className="nav-link ml-4 ">
                                Home
                            </Link>
                        </li>
                        <li className="nav-item ml-4">
                            <Link
                                to="/about"
                                className="nav-link ">
                                About
                            </Link>
                        </li>
                    </ul>
                    <ul className="navbar-nav nav-flex-icons">
                        <li className="nav-item">
                            <a href="https://www.facebook.com/iftixor.turamuradov" target="_blank" class="nav-link">
                                <i className="fab fa-facebook-f title"></i>
                            </a>
                        </li>
                        <li claclassNamess="nav-item">
                            <a href="https://wwww.twitter.com/iftixor-turamuradov" target="_blank" class="nav-link">
                                <i class="fab fa-twitter title"></i>
                            </a>
                        </li>
                        <li className="nav-item">
                            <a href="https://wwww.linkedin.com/in/iftixor-turamuradov-3062971b3" target="_blank" class="nav-link">
                                <i class="fab fa-linkedin-in title"></i>
                            </a>
                        </li>
                        <li className="nav-item ml-3">
                            <Link
                                to="/"
                                className="btn pink-gradient btn-rounded btn-sm font-weight-bold"
                                href="#contact" data-offset="90">
                                Log out
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    )
}

export default Navbar
